export const formatDate = (dateString: string) => dateString ? new Date(dateString).toLocaleDateString() : 'N/A';
export const formatTime = (dateString: string) => dateString ? new Date(dateString).toLocaleTimeString() : 'N/A';

export const setMidnight = (date: Date | null, isEnd: boolean = false) => {
    if (!date) return null;
     date.setHours(0, 0, 0, 0);
    return date.toISOString();
}